var map = {
	"./apple.svg": 14423,
	"./avatar.svg": 27690,
	"./bar-chart.svg": 93907,
	"./binocular.svg": 43816,
	"./bird-with-mail.svg": 3963,
	"./book-with-glasses.svg": 26988,
	"./broken-egg.svg": 7942,
	"./calendar.svg": 78447,
	"./chat.svg": 47859,
	"./chick.svg": 47559,
	"./clock.svg": 72929,
	"./cloud-network.svg": 55457,
	"./cogwheel.svg": 14891,
	"./coins.svg": 15753,
	"./confetti.svg": 99053,
	"./construction-worker.svg": 20169,
	"./contract.svg": 91707,
	"./credit-card-and-lock.svg": 36247,
	"./desert.svg": 35138,
	"./download.svg": 69937,
	"./egg-with-ribbon.svg": 55970,
	"./excel.svg": 95134,
	"./eye.svg": 54840,
	"./file-transfer.svg": 48621,
	"./file-with-barchart.svg": 57532,
	"./filter.svg": 92539,
	"./food-delivery.svg": 18706,
	"./gear-and-document.svg": 79446,
	"./hammer.svg": 97583,
	"./high-five.svg": 66550,
	"./hourglass.svg": 10173,
	"./internet.svg": 78990,
	"./light-bulb.svg": 30025,
	"./location.svg": 42768,
	"./magnifying-glass.svg": 1181,
	"./mobile-apps.svg": 46372,
	"./money-with-arrows-up.svg": 68023,
	"./nest-in-tree.svg": 12358,
	"./nest.svg": 23703,
	"./notebook.svg": 3358,
	"./pencil.svg": 75242,
	"./pinned-note.svg": 69872,
	"./plane.svg": 3117,
	"./pull-ups.svg": 89513,
	"./receipt.svg": 50451,
	"./ringing-bell.svg": 27473,
	"./roster.svg": 25180,
	"./search-money.svg": 7978,
	"./stopwatch.svg": 81202,
	"./sunbathing.svg": 51038,
	"./support.svg": 45598,
	"./tablet-touch-screen.svg": 67872,
	"./target-and-briefcase.svg": 56317,
	"./three-people-with-pointing-finger.svg": 45065,
	"./training.svg": 52275,
	"./trophy-number-one.svg": 91212,
	"./upload.svg": 83366,
	"./waving-people.svg": 70429,
	"./weighing-scale.svg": 93016,
	"./winning-man.svg": 33900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42801;